import { render } from "./UserRoleList.vue?vue&type=template&id=0031f7c6"
import script from "./UserRoleList.vue?vue&type=script&lang=js"
export * from "./UserRoleList.vue?vue&type=script&lang=js"

import "./UserRoleList.vue?vue&type=style&index=0&id=0031f7c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__